import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/landing.svg'
import _imports_1 from '@/assets/closing.svg'


const _withScopeId = n => (_pushScopeId("data-v-8de91f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home__main" }
const _hoisted_2 = { class: "home__section home__section--large" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { style: { marginBottom: 0 } }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: { marginTop: 0 } }, "design tokens.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Empower your token creation with our straightforward "),
  /*#__PURE__*/_createElementVNode("strong", null, "multi-brand"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "multi-theme"),
  /*#__PURE__*/_createTextVNode(" naming convention. ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  class: "home__section",
  id: "learn-more"
}, [
  /*#__PURE__*/_createElementVNode("h1", null, "Everything you need."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Save time, gain control, and switch seamlessly between "),
    /*#__PURE__*/_createElementVNode("strong", null, "multiple brands"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("strong", null, "themes"),
    /*#__PURE__*/_createTextVNode(". ")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "One dashboard, one source of truth"),
    /*#__PURE__*/_createTextVNode(" for all your tokens. ")
  ])
], -1))
const _hoisted_9 = { class: "home__section home__section--grid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Strict naming convention.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Forget about naming conventions. We take care of that for you.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Advanced token inheritance.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Easily create option, alias, and scoped tokens. We'll take care of their inheritance. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Advanced theming made easy.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create multiple brands and themes for your organization.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Full web support.", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Translate design tokens to CSS, SCSS, LESS, Stylus, CSV, JavaScript, and JSON. ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Integrates with your workflow.", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our exports comply 100% with the design tokens specification.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "One-click build step.", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Easily build to multiple platforms using our one-click build step. ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Multi-platform support.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Create, maintain, and distribute design tokens for web, iOS, and Android. ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Token distribution.", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Distribute your tokens through our secure content delivery network (CDN). ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Collaboration with your team.", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Invite unlimited team members to collaborate with you.", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "A true multilingual interface.", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Simplified version control.", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Create a new version after every token release, or whenever you see fit. ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "More than just design tokens.", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " For design and user experience decisions, as well as for utilities, assets, and textual content. ", -1))
const _hoisted_33 = { class: "home__section" }
const _hoisted_34 = ["alt"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Unleash the power of "),
  /*#__PURE__*/_createElementVNode("strong", null, "multi-brand"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "multi-theme"),
  /*#__PURE__*/_createTextVNode(" token systems with the most intuitive naming convention. ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  "data-tally-src": "https://tally.so/r/mZ9eay?transparentBackground=1",
  width: "100%",
  height: "100%",
  frameborder: "0",
  marginheight: "0",
  marginwidth: "0",
  title: "Towkns beta program form"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ml-embedded",
  "data-form": "WZtZ0Z"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: `${_ctx.TOWKNS_NAME} landing page image.`,
        class: "home__image"
      }, null, 8, _hoisted_3),
      _createElementVNode("h1", _hoisted_4, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.usp), 1)
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("button", {
        class: "cta",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openBetaProgramModal = true))
      }, " Apply for our beta program "),
      _createElementVNode("p", null, [
        _createTextVNode(" or "),
        _createElementVNode("button", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openWaitingListModal = true))
        }, " Join the waiting list ")
      ])
    ]),
    _hoisted_8,
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inBeta), 1)
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inBeta), 1)
        ]),
        _hoisted_12,
        _hoisted_13
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inBeta), 1)
        ]),
        _hoisted_14,
        _hoisted_15
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inBeta), 1)
        ]),
        _hoisted_16,
        _hoisted_17
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inBeta), 1)
        ]),
        _hoisted_18,
        _hoisted_19
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inBeta), 1)
        ]),
        _hoisted_20,
        _hoisted_21
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inDevelopment), 1)
        ]),
        _hoisted_22,
        _hoisted_23
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inDevelopment), 1)
        ]),
        _hoisted_24,
        _hoisted_25
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inDevelopment), 1)
        ]),
        _hoisted_26,
        _hoisted_27
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inDevelopment), 1)
        ]),
        _hoisted_28,
        _createElementVNode("p", null, [
          _createVNode(_component_Logo),
          _createTextVNode(" will initially support English and Spanish, but more languages will be added over time. ")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inResearch), 1)
        ]),
        _hoisted_29,
        _hoisted_30
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("em", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.inResearch), 1)
        ]),
        _hoisted_31,
        _hoisted_32
      ])
    ]),
    _createElementVNode("section", _hoisted_33, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: `${_ctx.TOWKNS_NAME} closing page image.`,
        class: "home__image"
      }, null, 8, _hoisted_34),
      _createElementVNode("h1", null, [
        _createTextVNode("We created "),
        _createVNode(_component_Logo),
        _createTextVNode(" with you in mind.")
      ]),
      _hoisted_35,
      _hoisted_36,
      _createElementVNode("button", {
        class: "cta",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openBetaProgramModal = true))
      }, " Apply for our beta program "),
      _createElementVNode("p", null, [
        _createTextVNode(" or "),
        _createElementVNode("button", {
          class: "link",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openWaitingListModal = true))
        }, " Join the waiting list ")
      ])
    ]),
    _createVNode(_component_Modal, {
      show: _ctx.openBetaProgramModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openBetaProgramModal = false))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent('script'), null, {
          default: _withCtx(() => [
            _createTextVNode(" var d = document, w = \"https://tally.so/widgets/embed.js\", v = function () { \"undefined\" != typeof Tally ? Tally.loadEmbeds() : d .querySelectorAll(\"iframe[data-tally-src]:not([src])\") .forEach(function (e) { e.src = e.dataset.tallySrc; }); }; if (d.querySelector('script[src=\"' + w + '\"]')) v(); else { var s = d.createElement(\"script\"); (s.src = w), (s.onload = v), (s.onerror = v), d.body.appendChild(s); } ")
          ]),
          _: 1
        })),
        _hoisted_37
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_Modal, {
      show: _ctx.openWaitingListModal,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openWaitingListModal = false))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent('script'), null, {
          default: _withCtx(() => [
            _createTextVNode(" (function (w, d, e, u, f, l, n) { (w[f] = w[f] || function () { (w[f].q = w[f].q || []).push(arguments); }), (l = d.createElement(e)), (l.async = 1), (l.src = u), (n = d.getElementsByTagName(e)[0]), n.parentNode.insertBefore(l, n); })( window, document, \"script\", \"https://assets.mailerlite.com/js/universal.js\", \"ml\" ); ml(\"account\", \"238705\"); ")
          ]),
          _: 1
        })),
        _hoisted_38
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}